import { CreateRedeemPayload, RedeemRequest } from "types/redeem";
import {
  createRedeemRequest as createRedeemApi,
  getRedeemRequests as getRedeemApi,
  getPendingRefunds as getPendingRefundsApi,
} from "utils/AxiosUtil";
import { NetworkType } from "utils/network";

async function createRedeemRequest(
  payload: CreateRedeemPayload,
  network: NetworkType,
): Promise<RedeemRequest> {
  const res = await createRedeemApi(payload, network);
  return res.data;
}

async function getRedeemRequests(
  merchantAddress: string,
  network: NetworkType,
  token?: string,
): Promise<RedeemRequest[]> {
  const res = await getRedeemApi(merchantAddress, network, token);
  return res.data;
}

async function getPendingReturnsCount(
  merchantAddress: string,
  network: NetworkType,
): Promise<{ count: number }> {
  const res = await getPendingRefundsApi(merchantAddress, network);
  return res.data;
}

const redeem_services = {
  createRedeemRequest,
  getRedeemRequests,
  getPendingReturnsCount,
};

export default redeem_services;
